import "./Nav.css";
import GCULogo from "./Grand_Canyon_University_2023_Logo_Update.png";
import { Link } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../apiConfig";

export default function Nav() {
  const { isAuthenticated, role, setAuthState } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      if (role === "student") {
        await axios.post(
          `${API_BASE_URL}/student/logout`,
          {},
          { withCredentials: true }
        );
      } else {
        await axios.post(
          `${API_BASE_URL}/admin/logout`,
          {},
          { withCredentials: true }
        );
      }
      setAuthState({ isAuthenticated: false, role: null });
      navigate("/");
      setIsMenuOpen(false); // Hide menu after logout
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Handler to close menu when a link is clicked
  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="customNav">
      <div className="left">
        <Link to="/" onClick={handleLinkClick}>
          <img className="GCULogoImage" src={GCULogo} alt="gcuLogo" />
        </Link>
      </div>

      {/* Menu Links */}
      <div className={`right ${isMenuOpen ? "menu-open" : ""}`}>
        {isAuthenticated ? (
          <>
            <Link to="/" className="LinkDashBoard" onClick={handleLinkClick}>
              Home
            </Link>
            {role !== "student" && (
              <>
                <Link
                  to="/landing"
                  className="LinkDashBoard"
                  onClick={handleLinkClick}
                >
                  Shop
                </Link>
                <Link
                  to="/signedInStudent"
                  className="LinkDashBoard"
                  onClick={handleLinkClick}
                >
                  Dashboard
                </Link>
              </>
            )}
            <Link
              to="/inventory"
              className="LinkDashBoard"
              onClick={handleLinkClick}
            >
              Inventory
            </Link>
            <Link
              to="/register"
              className="LinkDashBoard"
              onClick={handleLinkClick}
            >
              Register
            </Link>
            <button className="LinkLogout" onClick={handleLogout}>
              Logout
            </button>
          </>
        ) : (
          <>
            <Link
              to="/admin/login"
              className="LinkLogin"
              onClick={handleLinkClick}
            >
              Admin Login
            </Link>
            <Link
              to="/user/login"
              className="LinkLogin"
              onClick={handleLinkClick}
            >
              User Login
            </Link>
          </>
        )}
      </div>

      {/* Hamburger Icon */}
      <div className="hamburger" onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    </nav>
  );
}
